import CountryFlag from 'vue-country-flag-next'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default ({ app }) => {
  app.use(CountryFlag)
}
